var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/**
 * Constructs a url by joining together url segments into a full url.
 * Depending on the input of the first argument, this can either be a
 * relative, absolute or complete URL (staring with protocol like https)
 * @param paths
 * @returns
 */
export function urlJoin(...paths) {
    if (paths.length === 0) {
        return "/";
    }
    const [s, ...ps] = paths;
    let fullpath = s !== null && s !== void 0 ? s : "/";
    for (let p of ps) {
        fullpath = fullpath.replace(/(\/+)$/, "");
        fullpath = fullpath + "/" + p.replace(/^(\/)/, "");
    }
    return fullpath;
}
/**
 * Extends the standard URL class to allow chaining of paths
 * using the `joinPath` method.
 */
export class JURL extends URL {
    /**
     * Joins one or more path segments onto the current URL,
     * returning a new ChainableURL instance.
     * @param paths - Path segments to append
     * @returns A new ChainableURL with the joined path
     */
    joinPath(...paths) {
        const newurl = new JURL(this);
        newurl.pathname = urlJoin(this.pathname, ...paths);
        return newurl;
    }
}
export const createFormFromSelector = (qselector = {}) => {
    const sp = new URLSearchParams();
    const { select, sort, limit, cursor } = qselector, values = __rest(qselector, ["select", "sort", "limit", "cursor"]);
    console.log({ qselector });
    // add the 'select[X]' keyword
    for (let [k, v] of Object.entries(select !== null && select !== void 0 ? select : {})) {
        if (Array.isArray(v)) {
            for (let vx of v) {
                sp.append(`select[${k}]`, vx);
            }
        }
        else {
            sp.set(`select[${k}]`, v);
        }
    }
    // for the exact / ranged_values
    for (let [k, v] of Object.entries(values)) {
        if (typeof v === "object") {
            if ("from" in v || "to" in v) {
                const from_value = v["from"];
                if (from_value)
                    sp.set(`from[${k}]`, from_value);
                const to_value = v["to"];
                if (to_value)
                    sp.set(`to[${k}]`, to_value);
                continue;
            }
        }
        sp.set(`exact[${k}]`, v);
    }
    // for the sorting
    const objs = Object.entries(sort !== null && sort !== void 0 ? sort : {});
    if (objs.length >= 1) {
        // only use the first on to sort
        // assumption is, for the sql query you only need one
        let [k, order] = objs[0];
        sp.set(`sort[${k}]`, order);
    }
    if (limit) {
        sp.set("limit", String(limit));
    }
    if (cursor) {
        sp.set("cursor", cursor);
    }
    return sp;
};
